module.exports = __webpack_public_path__ + "img/us.uscb3557f.svg";